export enum TypoType {
    TEXT = 0,
    CODE = 1
}
